/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Fragment } from 'react';
export var InlineAddress = function (_a) {
    var address = _a.address;
    return address ? (jsx(Fragment, null, getAddressLines(address).join(', '))) : null;
};
export function getAddressLines(address) {
    return [address.line1, address.line2, address.town, address.postcode]
        .map(function (x) { return x === null || x === void 0 ? void 0 : x.trim(); })
        .filter(Boolean);
}
export function isEmptyAddress(address) {
    return !address || !getAddressLines(address).length;
}
//# sourceMappingURL=InlineAddress.js.map